import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'
import { IPartnerGroupAdditionalInfo } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IPartnerGroupAdditionalInfo'
import { BusinessPerformanceSwitcher } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/businessPerformanceSwitcher/BusinessPerformanceSwitcher'
import { getSteps } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/header/helpers/getSteps'
import { RollupSwitcher } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/rollupSwitcher/RollupSwitcher'
import React, { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Flex } from 'core-components/library/flex'

import { RoundTableSwitcher } from '../../../roundTable/components/roundTableSwitcher/RoundTableSwitcher'

import styles from './HeaderTitle.module.scss'

interface IProps {
  currentStep: number
  eltType: EltType
  companyName?: string
  onToggleBusinessPerformance?: (flag: boolean) => void
  isBusinessPerformanceTurnOn?: number
  onToggleRollupMode?: (flag: boolean) => void
  isRollupTurnOn?: number
  partnerGroupInfo?: IPartnerGroupAdditionalInfo
}

export const HeaderTitle = ({
  eltType,
  currentStep,
  companyName,
  onToggleBusinessPerformance,
  isBusinessPerformanceTurnOn,
  isRollupTurnOn,
  onToggleRollupMode,
  partnerGroupInfo,
}: IProps) => {
  const { title, subTitle, showCompanyName } = useMemo(() => {
    const steps = getSteps(eltType)
    return steps[currentStep] || { title: '', subTitle: '', showCompanyName: false }
  }, [currentStep, eltType])

  return (
    <div>
      <div className={styles.title}>
        <Translation text={title} />
        <RenderWhen condition={!!showCompanyName && !!companyName}>
          <>
            <span className={styles.divider}></span>
            <span>{companyName}</span>{' '}
          </>
        </RenderWhen>
      </div>
      <Flex alignItems={'center'} className={styles.controls}>
        <RenderWhen condition={!!subTitle}>
          <div className={styles.subTitle}>
            <Translation text={isDocType(eltType) ? `${subTitle}-${eltType}` : subTitle || ''} />
          </div>
        </RenderWhen>

        {onToggleBusinessPerformance && isDocType(eltType) ? (
          <BusinessPerformanceSwitcher
            isTurnOn={isBusinessPerformanceTurnOn}
            onChange={onToggleBusinessPerformance}
          />
        ) : null}
        {onToggleRollupMode && isDocType(eltType) && partnerGroupInfo ? (
          <RollupSwitcher
            isTurnOn={isRollupTurnOn}
            partnerGroupInfo={partnerGroupInfo}
            onToggleRollupMode={onToggleRollupMode}
          />
        ) : null}
        {isDocType(eltType) && <RoundTableSwitcher />}
      </Flex>
    </div>
  )
}
